import { Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { IdCard } from "../../components/IdCard";
import { useI18n } from "../../i18n";

export const IdCardDialog = ({ member, onClose }) => {
  const { t } = useI18n();
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[520px]" data-testid="idcard-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">{t("id_title")}</DialogTitle></DialogHeader>
        <div className="overflow-x-auto"><IdCard member={member} /></div>
        <button onClick={() => window.print()} className="btn-gold" data-testid="idcard-print-btn"><Printer className="h-4 w-4" />{t("id_print")}</button>
      </DialogContent>
    </Dialog>
  );
};
